var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex justify-center" }, [
    _c(
      "div",
      {
        ref: "imageHolder",
        staticClass: "image-holder cursor-pointer",
        class: { open: _vm.isOpen },
        on: {
          click: function($event) {
            return _vm.close()
          }
        }
      },
      [
        _c(
          "div",
          { staticClass: "images cursor-default" },
          _vm._l(_vm.images, function(item) {
            return _c("img", {
              key: item.id,
              staticClass: "lazyload mb-24 lg:mb-40 w-full",
              attrs: { id: "silder-image-" + item.id, "data-src": item.url },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            })
          }),
          0
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "close flex items-center bg-red text-white uppercase font-semi text-15 text-dark py-24 px-40 cursor-pointer duration-300 transition-all transform-gpu hover:scale-110",
        class: { open: _vm.isOpen },
        on: {
          click: function($event) {
            return _vm.close()
          }
        }
      },
      [
        _vm._v("\n        sluiten\n        "),
        _c("span", {
          staticClass: "ml-8",
          domProps: { innerHTML: _vm._s(_vm.svg("close")) }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }